/*
 * @Author: Tina Huang
 * @Date: 2024-02-27 17:08:52
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-06 14:10:59
 * @Description:
 */
export type NOTIFY_ITEM = {
  title: string
  time: string
  status: 'success' | 'processing' | 'error' | 'default' | 'warning' | undefined
  hide?: boolean
  btn: boolean
  btnPath?: any
  pathType?: 'navigate' | 'href'
  btnText?: string
  description?: string
  preview?: string
  previewLabel?: string
  cover?: string
}

type NEWS_TYPE = {
  datetime: string
  title: string
  msg: string
  show: boolean
  type: string
  page?: { name: string; params?: any }
  btnText?: string
  top?: boolean
}

export const notifies: NOTIFY_ITEM[] = [
  {
    title: '阿汪同学FlowUs合集订阅来啦！！',
    description: '前100位可获得一次5折定制',
    preview: 'https://flowus.cn/httishere/share/36ff537a-ab6a-4f65-8638-aa48f533becf?code=YJDF4B',
    previewLabel: '🔥模板预览',
    time: '2024-02-27 17:11:01',
    status: 'success',
    btn: true,
    btnPath: '/picks-detail/54',
    pathType: 'navigate',
    btnText: '我要订阅',
    cover: './assets/templates/temp-flowus.png',
    hide: true,
  },
]

export const news: NEWS_TYPE[] = [
  {
    datetime: '',
    title: '「预告」公式生成器正在开发中～',
    msg: '<p>好多小伙伴可能在公式运用中比较困难，而且搜寻公式也比较麻烦，所以我接下去会开发一个简易的公式生成器来满足一些基本场景，敬请期待～</p>',
    show: false,
    type: 'others',
  },
  {
    datetime: '2025/02/06 14:30',
    title: '💪 年后冲冲冲，又是新的一年，又是新的减肥计划！！',
    msg: "大家好呀，这里正是进入新的一年，很多小伙伴应该和我一样都又开始了新的一轮减肥计划，一起监督吧！<br><img src='./assets/news/bl_2025.1.png' />",
    show: true,
    type: 'update',
    page: { name: '/how-to-balance/2025-keep_2025.1' },
    btnText: '立即报名',
  },
  {
    datetime: '2024/11/29 17:10',
    title: '⚡️ 新模版放开拷贝！！体验一下爆改的感觉吧～',
    msg: "<img src='./assets/templates/2024-new-term/1.jpg' />",
    show: true,
    type: 'update',
    page: { name: '/picks-detail/84' },
    btnText: '立即拷贝',
  },
  {
    datetime: '2024/11/01 16:30',
    title: '🎉 「你想对我说」反馈征集@阿汪同学',
    msg: "<p>粉丝反馈征集活动，🎁 有机会在首页上榜或者获得随机红包或者店铺惊喜优惠券</p><img src='./assets/news/news-1101.png' /><img src='./assets/news/news-1101.2.png' />",
    show: true,
    type: 'others',
    btnText: '立即参与',
  },
  {
    datetime: '2024/09/30 14:30',
    title: '⚡️ 愿你有一个高能量的10月，国庆快乐🎉',
    msg: "<img src='./assets/templates/oct-power.jpg' />",
    show: true,
    type: 'update',
    page: { name: '/picks-detail/81' },
    btnText: '立即拷贝',
  },
  {
    datetime: '2024/08/21 17:10',
    title: '👗 整理星人必备｜打造自己的个人电子衣橱',
    msg: "<p>给自己建立一个一目了然的电子衣橱用来管理自己当前的所有衣服，也方便我们进行断舍离。</p><img src='./assets/templates/wardrobe.png' />",
    show: true,
    type: 'update',
    page: { name: '/picks-detail/78' },
  },
  {
    datetime: '2024/08/14 10:00',
    title: '❗️ Notion 积分打卡+热力打卡，一整个大开挂！',
    msg: "<p><span style='color:white;background-color: red;padding: 0 3px;'>内含尝鲜试用版</span>之前有和大家分享过我的积分打卡和热力打卡两个习惯养成的模版，有好多小伙伴希望我能把这两个结合一下，所以今天就来啦！在该体系内包含一个角色卡，习惯打卡热力，每日快捷打卡，积分任务，打卡计划进度，奖励商城等功能模块。</p><img src='./assets/templates/score3.0.jpg' />",
    show: true,
    type: 'update',
    page: { name: '/picks-detail/77' },
  },
  {
    datetime: '2024/08/06 16:35',
    title: '❗️ 推出监督打卡栏目',
    msg: "<p>因为阿汪是一个自驱力比较差的人，需要有人一起监督才会成长，所以在这里我推出了「监督打卡栏目」，这里我会放开一些一起挑战打卡的计划，可以和大家一起参与记录，参与打卡！</p><img src='./assets/news/challenges.png' />",
    show: true,
    type: 'update',
    page: { name: '/how-to-balance' },
  },
  {
    datetime: '2024/07/15 12:48',
    title: 'iOS记账快捷指令终于来啦！！',
    msg: "<p style='color: red;font-weight:bold; font-size: 16px;'>❗️ 已购买过记账模版的小伙伴可通过下单平台联系客服领取快捷指令～</p><img src='./assets/templates/iOS-jz1.JPG' />",
    show: true,
    type: 'others',
    page: { name: '/picks-detail/73' },
  },
  {
    datetime: '2024/05/07 12:30',
    title: '2024版可视化周计划复盘来啦！内含试用版',
    msg: "<img src='./assets/templates/2024weekly/Notion.jpg' />",
    show: true,
    type: 'update',
    page: { name: '/picks-detail/68' },
  },
  {
    datetime: '2024/04/29 18:10',
    title: '模板永久订阅调价倒计时24小时',
    msg: "<img class='image w-full' src='./assets/vip-20240429.png' />",
    show: true,
    type: 'update',
    page: { name: '/vips' },
    btnText: '立即订阅',
  },
  {
    datetime: '2024/04/28 13:40',
    title: '心情日记 + 情绪管理把你拿捏的死死的',
    msg: "<div class='flex'><img class='image w-1/2' src='./assets/templates/mood/mood-0.jpg' /><img class='image w-1/2' src='./assets/templates/memo/memo.png' /></div>",
    show: true,
    type: 'update',
    page: { name: '/picks' },
  },
  {
    datetime: '2024/04/11 18:20',
    title: 'Notion模板合集又来啦！32个模板直接打包带走',
    msg: "<img class='image' src='./assets/templates/2023-all/2.png' />",
    show: true,
    type: 'update',
    page: { name: '/picks-detail/63' },
    btnText: '立减46元',
  },
  {
    datetime: '2024/03/27 18:29',
    title: '历经1年半打造，个人知识库模板终于上线啦！',
    msg: "<img class='image' src='./assets/templates/brain/3.png' />",
    show: true,
    type: 'update',
    page: { name: '/picks-detail/57' },
    btnText: '限时立减10元',
  },
  {
    datetime: '2024/03/04 18:50',
    title: '组件库3.0上线啦！！！！',
    msg: "<img class='image' src='./assets/home.png' /><p>之前就有好多小伙伴反馈说组件库创建组件经常不成功或者卡顿，所以我重构了组件库技术栈！希望大家可以用得开心，并且我将取消组件库组件获取口令，大家都可以自由获取！</p>",
    show: true,
    type: 'update',
  },
  {
    datetime: '2024/03/04 12:38',
    title: '如何使用组件？',
    msg: '<li>第一步：点击组件详情下方「立即创建」。</li><li>第二步：打开你需要嵌入的页面（支持Notion，FlowUs，Obsidian，Wolai等），并在相应的位置创建一个空白块。</li><li>第三步：在空白块内直接粘贴刚才复制的组件，然后会自动出现操作联想选择<strong>「create embed」或者「网页嵌入」</strong>即可。</li><li>第四步：根据需要进行组件大小和位置调整</li><video src="./assets/embed.mov" controls autoPlay />',
    show: true,
    type: 'top',
  },
  {
    datetime: '2023/11/30 14:45',
    title: '更新Notion模板',
    msg: "<img class='image' src='./assets/news/news-1130.png' />",
    show: true,
    type: 'update',
    page: { name: '/picks' },
  },
  {
    datetime: '2023/10/21 14:35',
    title: '更新Notion公式2.0教程',
    msg: "<img class='image' src='./assets/templates/formula2.0.jpeg' />",
    show: true,
    type: 'update',
    page: { name: '/picks' },
  },
  {
    datetime: '2023/07/28 11:50',
    title: '新增多项组件',
    msg: "<img class='image' src='./assets/wids/widget-35.png' /><img class='image' src='./assets/wids/widget-36.png' /><img class='image' src='./assets/wids/widget-37.png' /><img class='image' src='./assets/wids/widget-38.png' />",
    show: true,
    type: 'update',
    page: { name: '/libs' },
  },
  {
    datetime: '2023/07/02 15:58',
    title: '上新啦！「简好用的todo list」模版',
    msg: "<img class='image' src='./assets/templates/temp-todo.JPG' />",
    show: true,
    type: 'update',
    page: { name: '/picks' },
  },
  {
    datetime: '2023/06/15 17:30',
    title: '👏 👏 阿汪同学模版库永久会员来啦！',
    msg: "<img class='image' src='./assets/news/news-0615.png' />",
    show: true,
    type: 'update',
    page: { name: '/vip' },
    btnText: '成为会员【限时立减 20】',
  },
  {
    datetime: '2023/04/20 15:20',
    title: '新增「考研计划」和「运动减肥计划」模版',
    msg: "<img class='image' src='./assets/templates/temp-kaoyan-2.jpg' /><br><img class='image' src='./assets/templates/temp-jianfei.jpg' />",
    show: true,
    type: 'update',
    page: { name: '/picks' },
  },
  {
    datetime: '2023/03/07 15:50',
    title: '新增「记账本 Pro版」模版',
    msg: "<p>新增：<br>✅ 贷记账户管理<br>✅ 月度账单报表</p><img class='image' src='./assets/templates/temp-jizhang-pro.jpg' />",
    show: true,
    type: 'update',
    page: { name: '/paid', params: { id: 16 } },
  },
  {
    datetime: '2023/03/02 13:17',
    title: '新增极简多项倒数日组件',
    msg: "<p>可设置多个倒数日，并从创建时开始自动计算时间进度</p><img class='image' src='./assets/wids/widget-33.2.png' /><img class='image' src='./assets/wids/widget-33.3.png' />",
    show: true,
    type: 'update',
    page: { name: '/create', params: { id: 33, type: 'time' } },
  },
  {
    datetime: '2023/02/26 14:00',
    title: '新增My days（倒数日&纪念日&正数日）组件',
    msg: "<p>可设置事项目标或开始日期，自动计算倒计时/正计时，可自定义背景色和文字颜色，同时提供15种背景图选择</p><img class='image' src='./assets/wids/widget-32.JPG' />",
    show: true,
    type: 'update',
    page: { name: 'create', params: { id: 32, type: 'time' } },
  },
  {
    datetime: '2023/02/15 22:00',
    title: '新增Notion设置循环任务教程',
    msg: "<p>该教程可在Notion-教程内查看</p><img class='image' src='./assets/templates/video-repeat.jpg' />",
    show: true,
    type: 'update',
    page: { name: 'picks' },
  },
  {
    datetime: '2023/02/08 22:56',
    title: '新增随机句子卡片组件',
    msg: "<p>该组件因使用其他API所以目前<strong class='focus'>限时开放已结束</strong>，可在组件-其他组件-随机句子组件查看使用</p><img class='image' src='./assets/wids/widget-1005.png' />",
    show: true,
    type: 'update',
    page: { name: 'time' },
  },
  {
    datetime: '2023/01/27',
    title: '新增区间进度条组件',
    msg: "<p>可设置事项开始结束日期，自动计算当前时间进度（单进度）</p><img class='image' src='./assets/wids/widget-31.png' />",
    show: true,
    type: 'update',
    page: { name: 'create', params: { id: 31, type: 'time' } },
  },
  {
    datetime: '2023/01/10',
    title: '新增组件评论区',
    msg: "<p>在组件页面可添加个人评论（无需注册），但请遵守网络规则文明用语，谢谢！</p><img class='image' src='./assets/news/news-0110.png' />",
    show: true,
    type: 'update',
  },
  {
    datetime: '2023/01/08',
    title: '新增范围日历',
    msg: "<p>可自定义范围日期以及高亮颜色，可在组件-时间组件-范围日历查看</p><img class='image' src='./assets/widget-29.png' />",
    show: true,
    type: 'update',
    page: { name: 'create', params: { id: 29, type: 'time' } },
  },
  {
    datetime: '2023/01/07',
    title: '新增快捷按钮组件',
    msg: "<p>提供多种应用图标，可自定义自己的快捷按钮，绑定文案和链接，可在组件-其他组件-快捷按钮查看</p><img class='image' src='./assets/tem-btn.png' />",
    show: true,
    type: 'update',
    page: { name: 'create', params: { id: 1004, type: 'others' } },
  },
  {
    datetime: '2023/01/05',
    title: '年度格子支持暗黑（dark）模式',
    msg: "<p>可在组件-时间组件-年度格子查看</p><img class='image' src='./assets/year-cells-dark.png' />",
    show: true,
    type: 'update',
    page: { name: 'create', params: { id: 7, type: 'time' } },
  },
  {
    datetime: '2022/12/24',
    title: '新增发光时钟组件',
    msg: "<p>可在组件-时间组件内查看</p><img class='image' src='./assets/shadow-clock.png' />",
    show: true,
    type: 'update',
  },
  {
    datetime: '2022/12/05',
    title: '组件库2.0版本已到达！',
    msg: "<p>因为身体的缘故导致<strong class='focus'>组件库2.0</strong>一拖再拖，终于在今天上线啦！</p><p>这次更新全面优化了组件库UI，增加多个组件以及增加自定义组件功能</p><p><strong class='focus'>Notion模版：</strong>多个Notion模版可供拷贝</p><p>如果在使用过程中遇到什么问题或者说对组件有什么建议可以通过右下角的<strong class='focus'>「问题反馈」</strong>反馈给我哦～</p><p>感谢大家的支持！！</p>",
    show: true,
    type: 'update',
  },
  {
    datetime: '2022/10/12',
    title: '部分组件为什么没有在组件库',
    msg: "<p>部分组件因特殊原因不可大量开放，所以我只在公众号<strong class='focus'>「汪汪汪世界」</strong>限定名额开放～</p>",
    show: true,
    type: 'others',
  },
]
